var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBullsEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.5 2C5.366 2 2 5.366 2 9.5S5.366 17 9.5 17 17 13.634 17 9.5 13.634 2 9.5 2m0 1.5c3.322 0 6 2.678 6 6s-2.678 6-6 6a5.99 5.99 0 0 1-6-6c0-3.322 2.678-6 6-6m0 1.5A4.51 4.51 0 0 0 5 9.5C5 11.976 7.024 14 9.5 14S14 11.976 14 9.5 11.976 5 9.5 5m0 1.5c1.667 0 3 1.333 3 3s-1.333 3-3 3-3-1.333-3-3 1.333-3 3-3m0 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 1 0 0-3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBullsEye);
export default ForwardRef;